export var CommonConst = {
  projectName: 'AnnexTravel'
};
export var CookieKey = {
  LANGUAGE: 'l',
  THEME: 't'
};